// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__nRujp","title":"AfterFrontImage_title__2VOZW"};